import { c as _c } from "react/compiler-runtime";
import { Text, VStack, Link, SimpleGrid, Box, Button } from '@chakra-ui/react';
import { IndustryAndVerticalTagInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/IndustryAndVerticalTagInput';
import { InvestmentStageTagInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/InvestmentStageTagInput';
import { InvestorTypeTagInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/InvestorTypeTagInput';
import { KeywordInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/KeywordInput';
import { LocationSelectAndDistanceInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/LocationSelectAndDistanceInput';
import { ToggleInput } from '@src/components/sco/InvestorSearch/InvestorSearchFilters/ToggleInput';
import { InvestorSearchFilters, useInvestorSearchContext } from '@src/components/sco/InvestorSearch/Layout/InvestorSearchContext';
import { usePathname, useRouter } from 'next/navigation';
import React, { useState } from 'react';
import { LuDollarSign } from 'react-icons/lu';
type InvestorSearchFilterFormProps = {
  collapsed?: boolean;
};
export const InvestorSearchFilterForm = props => {
  const $ = _c(95);
  const investorSearchContext = useInvestorSearchContext();
  const [values, setValues] = useState(investorSearchContext.filterValues);
  const [filtersChanged, setFiltersChanged] = useState(false);
  const pathname = usePathname();
  const router = useRouter();
  let t0;
  if ($[0] !== filtersChanged) {
    t0 = (key, value) => {
      setValues(prevValues => ({
        ...prevValues,
        [key]: value
      }));
      if (!filtersChanged) {
        setFiltersChanged(true);
      }
    };
    $[0] = filtersChanged;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const setValue = t0;
  let t1;
  if ($[2] !== investorSearchContext || $[3] !== pathname || $[4] !== router || $[5] !== values) {
    const handleSubmit = () => {
      if (!["/investors/search", "/investors/saved"].includes(pathname)) {
        router.push(`/investors/search?${new URLSearchParams(values as any).toString()}`.replaceAll("null", ""));
        return;
      }
      Object.keys(values).forEach(key_0 => {
        investorSearchContext.setFilter(key_0, values[key_0]);
      });
      setFiltersChanged(false);
    };
    t1 = e => {
      e.preventDefault();
      handleSubmit();
    };
    $[2] = investorSearchContext;
    $[3] = pathname;
    $[4] = router;
    $[5] = values;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== setValue) {
    t2 = value_0 => setValue("keywords", value_0);
    $[7] = setValue;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== investorSearchContext.filterValues.keywords || $[10] !== t2) {
    t3 = <KeywordInput defaultValue={investorSearchContext.filterValues.keywords} label="Investor Name" placeholder="Investor Name..." onChange={t2} />;
    $[9] = investorSearchContext.filterValues.keywords;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text marginBottom={4} textStyle="label2xs">Investment Amount</Text>;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const t5 = `${investorSearchContext.filterValues.minimumInvestmentInDollars || ""}`;
  let t6;
  if ($[13] !== setValue) {
    t6 = value_1 => setValue("minimumInvestmentInDollars", value_1);
    $[13] = setValue;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t5 || $[16] !== t6) {
    t7 = <KeywordInput defaultValue={t5} icon={LuDollarSign} placeholder="Min" onChange={t6} />;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const t8 = `${investorSearchContext.filterValues.maximumInvestmentInDollars || ""}`;
  let t9;
  if ($[18] !== setValue) {
    t9 = value_2 => setValue("maximumInvestmentInDollars", value_2);
    $[18] = setValue;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <KeywordInput defaultValue={t8} icon={LuDollarSign} placeholder="Max" onChange={t9} />;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t7) {
    t11 = <Box width="full">{t4}<SimpleGrid columns={2} gap="1em">{t7}{t10}</SimpleGrid></Box>;
    $[23] = t10;
    $[24] = t7;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text marginBottom={4} textStyle="label2xs">{"Industries & Verticals"}</Text>;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== investorSearchContext.filterValues.preferredIndustriesAndVerticals) {
    t13 = investorSearchContext.filterValues.preferredIndustriesAndVerticals?.filter(Boolean);
    $[27] = investorSearchContext.filterValues.preferredIndustriesAndVerticals;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== setValue) {
    t14 = values_0 => setValue("preferredIndustriesAndVerticals", values_0);
    $[29] = setValue;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <Box width="full">{t12}<IndustryAndVerticalTagInput defaultValue={t13} onChange={t14} /></Box>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Text marginBottom={4} textStyle="label2xs">Investor Types</Text>;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== setValue) {
    t17 = values_1 => setValue("investorTypes", values_1);
    $[35] = setValue;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== investorSearchContext.filterValues.investorTypes || $[38] !== t17) {
    t18 = <Box width="full">{t16}<InvestorTypeTagInput defaultValue={investorSearchContext.filterValues.investorTypes} onChange={t17} /></Box>;
    $[37] = investorSearchContext.filterValues.investorTypes;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Text marginBottom={4} textStyle="label2xs">Investment Stages</Text>;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== setValue) {
    t20 = values_2 => setValue("investmentStages", values_2);
    $[41] = setValue;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== investorSearchContext.filterValues.investmentStages || $[44] !== t20) {
    t21 = <Box width="full">{t19}<InvestmentStageTagInput defaultValue={investorSearchContext.filterValues.investmentStages} onChange={t20} /></Box>;
    $[43] = investorSearchContext.filterValues.investmentStages;
    $[44] = t20;
    $[45] = t21;
  } else {
    t21 = $[45];
  }
  let t22;
  if ($[46] !== values.hqLatitude || $[47] !== values.hqLocation || $[48] !== values.hqLongitude) {
    t22 = values.hqLocation && values.hqLatitude && values.hqLongitude ? {
      title: values.hqLocation,
      latitude: values.hqLatitude,
      longitude: values.hqLongitude
    } : null;
    $[46] = values.hqLatitude;
    $[47] = values.hqLocation;
    $[48] = values.hqLongitude;
    $[49] = t22;
  } else {
    t22 = $[49];
  }
  let t23;
  if ($[50] !== investorSearchContext.filterValues.hqDistanceInMiles || $[51] !== investorSearchContext.filterValues.hqLocationCountry || $[52] !== investorSearchContext.filterValues.hqLocationRegion || $[53] !== t22) {
    t23 = {
      distanceInMiles: investorSearchContext.filterValues.hqDistanceInMiles,
      region: investorSearchContext.filterValues.hqLocationRegion,
      country: investorSearchContext.filterValues.hqLocationCountry,
      place: t22
    };
    $[50] = investorSearchContext.filterValues.hqDistanceInMiles;
    $[51] = investorSearchContext.filterValues.hqLocationCountry;
    $[52] = investorSearchContext.filterValues.hqLocationRegion;
    $[53] = t22;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  let t25;
  let t26;
  let t27;
  if ($[55] !== setValue) {
    t24 = value_3 => setValue("hqLocationCountry", value_3);
    t25 = value_4 => setValue("hqDistanceInMiles", value_4 ? parseInt(`${value_4}`) : null);
    t26 = value_5 => setValue("hqLocationRegion", value_5);
    t27 = place => {
      setValue("hqLocation", place?.title || null);
      setValue("hqLatitude", place?.latitude || null);
      setValue("hqLongitude", place?.longitude || null);
    };
    $[55] = setValue;
    $[56] = t24;
    $[57] = t25;
    $[58] = t26;
    $[59] = t27;
  } else {
    t24 = $[56];
    t25 = $[57];
    t26 = $[58];
    t27 = $[59];
  }
  let t28;
  if ($[60] !== t23 || $[61] !== t24 || $[62] !== t25 || $[63] !== t26 || $[64] !== t27) {
    t28 = <LocationSelectAndDistanceInput label="Location & Distance" defaultValues={t23} onCountryChange={t24} onDistanceChange={t25} onRegionChange={t26} onPlaceChange={t27} />;
    $[60] = t23;
    $[61] = t24;
    $[62] = t25;
    $[63] = t26;
    $[64] = t27;
    $[65] = t28;
  } else {
    t28 = $[65];
  }
  let t29;
  if ($[66] !== setValue) {
    t29 = value_6 => setValue("matchAll", value_6);
    $[66] = setValue;
    $[67] = t29;
  } else {
    t29 = $[67];
  }
  let t30;
  if ($[68] !== investorSearchContext.filterValues.matchAll || $[69] !== t29) {
    t30 = <ToggleInput defaultValue={investorSearchContext.filterValues.matchAll} label="Match All Filters" onChange={t29} />;
    $[68] = investorSearchContext.filterValues.matchAll;
    $[69] = t29;
    $[70] = t30;
  } else {
    t30 = $[70];
  }
  let t31;
  if ($[71] !== setValue) {
    t31 = <ToggleInput label="Show Verified Only" onChange={value_7 => setValue("isVerified", value_7)} />;
    $[71] = setValue;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  let t32;
  if ($[73] !== t30 || $[74] !== t31) {
    t32 = <SimpleGrid columns={1} gap="1em">{t30}{t31}</SimpleGrid>;
    $[73] = t30;
    $[74] = t31;
    $[75] = t32;
  } else {
    t32 = $[75];
  }
  const t33 = !filtersChanged;
  const t34 = filtersChanged ? "cta" : "outline";
  const t35 = filtersChanged ? "Apply Filters" : "Filters Applied";
  let t36;
  if ($[76] !== t33 || $[77] !== t34 || $[78] !== t35) {
    t36 = <Button disabled={t33} type="submit" variant={t34}>{t35}</Button>;
    $[76] = t33;
    $[77] = t34;
    $[78] = t35;
    $[79] = t36;
  } else {
    t36 = $[79];
  }
  let t37;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <Button asChild={true} variant="outline"><Link href="/investors/search">Reset Filters</Link></Button>;
    $[80] = t37;
  } else {
    t37 = $[80];
  }
  let t38;
  if ($[81] !== t36) {
    t38 = <VStack align="stretch">{t36}{t37}</VStack>;
    $[81] = t36;
    $[82] = t38;
  } else {
    t38 = $[82];
  }
  let t39;
  if ($[83] !== t11 || $[84] !== t15 || $[85] !== t18 || $[86] !== t21 || $[87] !== t28 || $[88] !== t3 || $[89] !== t32 || $[90] !== t38) {
    t39 = <Box height="full" overflowY="auto" paddingY={4}><VStack align="stretch" gap="1.33em">{t3}{t11}{t15}{t18}{t21}{t28}{t32}{t38}</VStack></Box>;
    $[83] = t11;
    $[84] = t15;
    $[85] = t18;
    $[86] = t21;
    $[87] = t28;
    $[88] = t3;
    $[89] = t32;
    $[90] = t38;
    $[91] = t39;
  } else {
    t39 = $[91];
  }
  let t40;
  if ($[92] !== t1 || $[93] !== t39) {
    t40 = <form onSubmit={t1}>{t39}</form>;
    $[92] = t1;
    $[93] = t39;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  return t40;
};